import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { ReactComponentType } from '../types';

import { FrequentlyAskedQuestions } from './FrequentlyAskedQuestions';
import { FrequentlyAskedQuestionsStrapiComponent } from './types';

export const collectFrequentlyAskedQuestionsComponentParams = (
  data: FrequentlyAskedQuestionsStrapiComponent
) => {
  const items = data.items?.map((x) => ({
    title: x.title,
    text: x.text,
  }));

  return {
    items: items,
    variation: data.variation ?? 'oneColumn',
  };
};

export const collectFrequentlyAskedQuestionsParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof FrequentlyAskedQuestions> | undefined => {
  if (!('frequentlyAskedQuestions' in page) || !page.frequentlyAskedQuestions) {
    return undefined;
  }

  return {
    component: ReactComponentType.FrequentlyAskedQuestions,
    props: collectFrequentlyAskedQuestionsComponentParams(
      page.frequentlyAskedQuestions
    ),
  };
};
